import { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'components/UI/InputNumber/InputNumber';
import { Button } from 'components/UI/Button/Button';
import { ReactComponent as IconApproved } from 'assets/icons/svgs/icon-approved.svg';

export const BookPanelSinglePriceType = (props) => {
  const {
    Performance: { PerformanceId, Sections, ProductionSeasonId, PriceTypes, MaxTicketsPerOrder },
    handleAddUpsellToCart = () => {},
    isProcessing,
    errorMessage = '',
    numberOfUpsellSelected,
    msgAddedRef,
  } = props;
  const [updateCartBtnDisabled, setUpdateCartBtnDisabled] = useState(true);
  const [selectedUpsells, setSelectedUpsells] = useState([]);
  const [clickedUpdateButtonEl, setClickedUpdateButtonEl] = useState();

  const incrementChangeHandler = (priceTypeId, numSeats) => {
    setSelectedUpsells([
      {
        PriceTypeId: priceTypeId,
        NumSeats: numSeats,
      },
    ]);

    setUpdateCartBtnDisabled(false);
  };

  const decrementChangeHandler = (priceTypeId, numSeats) => {
    const updatedUpsells =
      numSeats === 0
        ? []
        : [
            {
              PriceTypeId: priceTypeId,
              NumSeats: numSeats,
            },
          ];
    setSelectedUpsells(updatedUpsells);

    setUpdateCartBtnDisabled(false);
  };

  const updateCartButtonClickHandler = (event) => {
    setClickedUpdateButtonEl(event.target);

    const requestPayload = {
      PerformanceId,
      PriceTypes: selectedUpsells,
      ProdSeasonId: ProductionSeasonId,
      ZoneId: Sections[0].ZoneId,
    };

    handleAddUpsellToCart(requestPayload, msgAddedRef.current);
  };

  useEffect(() => {
    if (isProcessing) {
      setUpdateCartBtnDisabled(true);
    } else {
      // Reset the button element clicked when done processing
      setClickedUpdateButtonEl(null);
    }

    const buttonText = isProcessing ? 'Processing...' : 'Update the cart';
    if (clickedUpdateButtonEl) {
      clickedUpdateButtonEl.innerHTML = buttonText;
    }
  }, [isProcessing]);

  return PriceTypes.map((priceType) => {
    const { Id, AliasDescription, Description, PriceRange, NumberOfSeatSelected } = priceType;

    return (
      <Fragment key={Id}>
        <div className="add-item">
          <span className="item-price">
            {AliasDescription ? (
              <span className="sub">{AliasDescription}</span>
            ) : (
              <span className="sub">{Description}</span>
            )}{' '}
            {PriceRange} <span className="unit">each</span>
          </span>
          <InputNumber
            id={Id}
            maxValue={MaxTicketsPerOrder}
            incrementChangeHandler={incrementChangeHandler}
            decrementChangeHandler={decrementChangeHandler}
            defaultValue={NumberOfSeatSelected}
          />
        </div>

        <Button
          extendClass={`btn-small btn-add ${updateCartBtnDisabled ? 'disabled' : ''}`}
          onClick={updateCartButtonClickHandler}
          variant="primary"
          disabled={updateCartBtnDisabled}
          extendTestId="update-cart"
        >
          <span>Update the cart</span>
        </Button>

        {errorMessage && (
          <div>
            <p className="error-message text-right">{errorMessage}</p>
          </div>
        )}

        <div className="msg-added" ref={msgAddedRef}>
          {numberOfUpsellSelected > 0 && (
            <>
              <IconApproved className="icon fill-teal" />
              {numberOfUpsellSelected} added to cart
            </>
          )}
        </div>
      </Fragment>
    );
  });
};

BookPanelSinglePriceType.propTypes = {
  Performance: PropTypes.object,
  isProcessing: PropTypes.bool,
  errorMessage: PropTypes.string,
  msgAddedRef: PropTypes.object,
  numberOfUpsellSelected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
